module.exports = __webpack_public_path__ + "static/media/no-image.8bd3435c.svg";